import { render, staticRenderFns } from "./PhoneProfile.vue?vue&type=template&id=144455f1&scoped=true&"
import script from "./PhoneProfile.vue?vue&type=script&lang=js&"
export * from "./PhoneProfile.vue?vue&type=script&lang=js&"
import style0 from "./PhoneProfile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PhoneProfile.vue?vue&type=style&index=1&id=144455f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144455f1",
  null
  
)

export default component.exports